import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { CalendarSurfaceStore } from 'owa-calendar-surface-dategrid';
import { shouldShowDeclinedEvents } from 'owa-show-declined-meetings-user-config';

export function getSurfaceItems(surfaceStore: CalendarSurfaceStore): CalendarEvent[] {
    let items = surfaceStore.calendarItems;
    if (!shouldShowDeclinedEvents()) {
        items = surfaceStore.calendarItems.filter(item => item.ResponseType != 'Decline');
    }
    return items;
}
